import { Settings } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const taskExecutionMethodOptions: ComboboxFilterOption<string>[] = [
  { label: 'Manual', value: 'manual' },
  { label: 'Automated', value: 'automated' },
]

const NextTaskExecutionMethodFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = taskExecutionMethodOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Task Execution', options: filteredOptions || [] }]}
        placeholder='Search execution methods to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={taskExecutionMethodOptions || []}
          noSelectionText='Task Execution'
          pluralIdentifier='task execution methods'
        >
          <Settings size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default NextTaskExecutionMethodFilter
